import TextRow from './TextRow';

export default TextRow;
